module.exports = __webpack_public_path__ + "static/media/Avenir-Book.85a6503d.woff2";